











































































import { Action, Getter } from 'vuex-class'
import { arriveParkingService } from '@/services/api/arrive-parking.service'
import { Component, Emit, Prop, Watch, Vue } from 'vue-property-decorator'
import { emitEvent, unregisterEvent, registerEvent, AxEventType } from '@aspenware-library/event-hub'
import { endsWith } from 'lodash'
import { format } from 'date-fns'
import { ParkingLocationInterface } from '@/interfaces/entities/parking-location.interface'

@Component({
  name: 'ArriveLocationsList',
})
export default class ArriveLocationsList extends Vue {
  private expanded: any[] = []
  private expandedLocation: number = -1
  private loadingLocations: number[] = []
  private locations: any[] = []
  private locationsByDateTime: any = {}
  private photoFlexBasis = 40
  private selectedDate: string = ''
  private selectedLocationId: number = -1
  private selectedDateTime: string = ''
  private highlightLocations: boolean = false

  @Getter('cart/cartAdding') addingToCart

  created() {
    registerEvent('ASPENWARE_ARRIVE_DAYSELECTED', this.onDaySelected)
    registerEvent('ASPENWARE_ARRIVE_SELECTLOCATION', this.onSelectLocation)
  }

  destroyed() {
    unregisterEvent('ASPENWARE_ARRIVE_DAYSELECTED')
  }

  get contentFlexBasis() {
    return 100 - this.photoFlexBasis
  }
  get formattedSelectedDate() {
    const dateKey = `${this.selectedDate}T00:00:00`
    return format(new Date(dateKey), 'EEEE, MMM dd, yyyy')
  }

  get languageSettings(): any {
    // arriveParkingSettings declared in global.d.ts
    return window.arriveParkingSettings?.LanguageStrings || {}
  }

  get locationHeaders() {
    return [
      {
        align: 'start',
        sortable: false,
        value: 'lotName',
      },
      {
        align: 'start',
        sortable: false,
        value: 'address',
      },
      {
        align: 'start',
        sortable: false,
        value: 'button',
      },
    ]
  }

  private async loadFullLocation(location) {
    this.loadingLocations = [...this.loadingLocations, location.locationId]
    const fullLocData = await arriveParkingService.getLocation(location.locationId)
    const loadingLocationsWithoutCurrent = this.loadingLocations.filter((l) => l !== location.locationId)
    this.loadingLocations = loadingLocationsWithoutCurrent
    const newLocation = {
      ...location,
      ...fullLocData,
      fullDataLoaded: true,
    }
    const locationIndex = this.locations.findIndex((l) => l.locationId === location.locationId)
    // Replacing regular (non date sorted locations)
    const newLocations = this.locations.map((l) => {
      return l.locationId === newLocation.locationId ? newLocation : l
    })
    this.locations = newLocations

    // Replacing date-sorted locations
    const dateKeys = Object.keys(this.locationsByDateTime)
    dateKeys.forEach((key, index) => {
      const newDateLocations = this.locationsByDateTime[key].map((l) => {
        return l.locationId === newLocation.locationId ? newLocation : l
      })
      this.locationsByDateTime[key] = newDateLocations
    })
  }

  private async onDaySelected(availabilityInfo) {
    this.clearSelectedLocation()
    this.selectedDate = availabilityInfo.date
    this.locations = availabilityInfo?.availability?.lots
    this.locationsByDateTime = availabilityInfo?.availability?.lotsByDateTime
    this.scrollToList()
    this.highlightLocations = false
  }

  private priceValue(location) {
    const price = parseFloat(location.price).toFixed(2)
    let priceString = `$${price}`
    if (priceString && endsWith(priceString, '.00')) {
      priceString = priceString.substring(0, priceString.length - 3)
    }
    return priceString
  }

  private clearSelectedLocation() {
    this.selectedLocationId = -1
    this.selectedDateTime = ''
    this.expandedLocation = -1
    emitEvent('ASPENWARE_ARRIVE_LOCATIONSELECTED', null)
    this.$emit('ASPENWARE_ARRIVE_LOCATIONSELECTED', null) // Included for debugging purposes
  }

  private expandLocation(location) {
    if (this.expandedLocation !== location.locationId) {
      this.expandedLocation = location.locationId
      this.loadFullLocation(location)
    } else {
      this.expandedLocation = -1
    }
  }

  private localTime(GMTDate: string): string {
    return format(new Date(GMTDate), 'H:mm aa')
  }

  private lotStartTime(location, timeOnly) {
    const Time = this.localTime(location.date)
    const multipleTimes = Object.keys(this.locationsByDateTime).length > 1
    const labelTemplate = this.languageSettings.LotStartTime || 'Starts at ${Time}'

    if (timeOnly) {
      return multipleTimes ? Time : ''
    }

    return multipleTimes ? eval('`' + labelTemplate + '`') : ''
  }

  private onLocationExpanded({ item, value }) {
    if (value && !item.fullDataLoaded) {
      this.loadFullLocation(item)
    }
  }

  private onSelectLocation() {
    this.highlightLocations = true
    this.scrollToList()
    setTimeout(() => {
      this.highlightLocations = false
    }, 1000)
  }

  private reservationStartTimeHeader(DateTime) {
    const Time = format(new Date(DateTime), 'H:mm aa')
    const labelTemplate = this.languageSettings.LocationListStartTime || 'These reservations start at ${Time}'
    return eval('`' + labelTemplate + '`')
  }

  private selectLocation(location) {
    const thisLocation = {
      ...location,
    }
    // Reset expanded location if you are choosing a different location from the one expanded
    if (this.expandedLocation !== thisLocation.locationId) {
      this.expandedLocation = -1
    }
    this.selectedLocationId = thisLocation.locationId
    this.selectedDateTime = thisLocation.date
    this.highlightLocations = false
    if (this.lotStartTime(location, true)) {
      thisLocation.startTime = `${this.lotStartTime(thisLocation, true)}`
    }
    emitEvent('ASPENWARE_ARRIVE_LOCATIONSELECTED', thisLocation)
    this.$emit('ASPENWARE_ARRIVE_LOCATIONSELECTED', thisLocation) // Included for debugging purposes
  }

  private scrollToList() {
    const isMobile = this.$vuetify.breakpoint.mobile
    const listElement = isMobile
      ? document.getElementsByClassName('parking-info-expansion')[0]
      : document.getElementsByClassName('required-attribute-list')[0]

    setTimeout(() => {
      if (listElement) {
        listElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      }
    }, 250)
  }

  private togglePhotoSize() {
    const photoSize = this.photoFlexBasis === 40 ? 80 : 40
    this.photoFlexBasis = photoSize
  }
}
